import * as axios from "axios";

const forgotPassword = async function(email) {
  try {
    const response = await axios.post(
      process.env.VUE_APP_SERVICE_URL + "/forgotpassword",
      email
    );
    if (response.status !== 200) throw Error(response.message);
    return;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getAccountCredit = async function(id, token) {
  try {
    axios.defaults.headers.common["Authorization"] = token;
    const response = await axios.get(
      process.env.VUE_APP_SERVICE_URL + "/account/" + id + "/credit"
    );

    if (response.status !== 200) throw Error(response.message);
    if (!response.data) {
      return null;
    }
    let creditAmount = response.data;
    if (typeof creditAmount !== "number") {
      creditAmount = 0;
    }
    return creditAmount;
  } catch (error) {
    console.error("getAccountCredit", error);
    throw error;
  }
};

const checkEmail = async function(email) {
  try {
    //axios.defaults.headers.common["Authorization"] = token;
    const response = await axios.get(
      process.env.VUE_APP_SERVICE_URL + "/account/email/check?email=" + email
    );

    if (response.status !== 200) throw Error(response.message);
    if (!response.data) {
      return false;
    }
    let validEmail = response.data;
    if (typeof validEmail !== "boolean") {
      validEmail = false;
    }
    return validEmail;
  } catch (error) {
    console.error("checkEmail", error);
    throw error;
  }
};

const getAccount = async function(id, token) {
  try {
    axios.defaults.headers.common["Authorization"] = token;
    const response = await axios.get(
      process.env.VUE_APP_SERVICE_URL + "/account/" + id
    );

    if (response.status !== 200) throw Error(response.message);
    if (!response.data) {
      return null;
    }
    console.log("response.data", response.data);
    let account = response.data;
    if (typeof account !== "object") {
      account = null;
    }
    return account;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const updateAccount = async function(accountEdit, token) {
  try {
    axios.defaults.headers.common["Authorization"] = token;
    const response = await axios.patch(
      process.env.VUE_APP_SERVICE_URL + "/account",
      accountEdit
    );

    if (response.status !== 200) throw Error(response.message);
    if (!response.data) {
      return null;
    }
    console.log("response.data", response.data);
    let account = response.data;
    if (typeof account !== "object") {
      account = null;
    }
    return account;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const updateAccountEmail = async function(model, token) {
  try {
    axios.defaults.headers.common["Authorization"] = token;
    const response = await axios.patch(
      process.env.VUE_APP_SERVICE_URL + "/account/email",
      model
    );

    if (response.status !== 200) throw Error(response.message);
    if (!response.data) {
      return null;
    }
    console.log("response.data", response.data);
    let account = response.data;
    if (typeof account !== "object") {
      account = null;
    }
    return account;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const updatePassword = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/password",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let account = response.data;
  if (typeof account !== "object") {
    account = null;
  }
  return account;
};

const addExamRegistration = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.post(
    process.env.VUE_APP_SERVICE_URL + "/account/child/examregistration",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let account = response.data;
  if (typeof account !== "object") {
    account = null;
  }
  return account;
};

const addCreditRecord = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.post(
    process.env.VUE_APP_SERVICE_URL + "/account/creditrecord",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let creditRecord = response.data;
  if (typeof creditRecord !== "object") {
    creditRecord = null;
  }
  return creditRecord;
};

const deleteChild = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/account/child/delete",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let account = response.data;
  if (typeof account !== "object") {
    account = null;
  }
  return account;
};

const refundExamRegistration = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/account/child/examregistration/refund",
    model
  );
  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let account = response.data;
  if (typeof account !== "object") {
    account = null;
  }
  return account;
};

const deleteExamRegistration = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/account/child/examregistration",
    model
  );
  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let account = response.data;
  if (typeof account !== "object") {
    account = null;
  }
  return account;
};

const deleteSchoolYear = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/schoolyear/delete",
    model
  );
  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  return model.schoolYearId;
};

const deleteLocation = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/location/delete",
    model
  );
  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  return model.locationId;
};

const deleteParent = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/parent/delete",
    model
  );
  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  return model.accountId;
};

const deletePendingAccount = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/pendingaccount",
    model
  );
  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  return model.pendingAccountId;
};

const confirmPendingAccount = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  console.log("calling the post");
  const response = await axios.post(
    process.env.VUE_APP_SERVICE_URL + "/pendingaccount",
    model
  );
  console.log("confirmPendingAccount response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  return model.pendingAccountId;
};

const addChild = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.post(
    process.env.VUE_APP_SERVICE_URL + "/account/child",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let account = response.data;
  if (typeof account !== "object") {
    account = null;
  }
  return account;
};

const addSchoolYear = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.post(
    process.env.VUE_APP_SERVICE_URL + "/schoolyear",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let schoolYear = response.data;
  if (typeof schoolYear !== "object") {
    schoolYear = null;
  }
  return schoolYear;
};

const addLocation = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.post(
    process.env.VUE_APP_SERVICE_URL + "/location",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let location = response.data;
  if (typeof location !== "object") {
    location = null;
  }
  return location;
};

const updateChild = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/account/child",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let account = response.data;
  if (typeof account !== "object") {
    account = null;
  }
  return account;
};

const updateExamRegistrationCredit = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/examregistration/credit",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let account = response.data;
  if (typeof account !== "object") {
    account = null;
  }
  return account;
};

const updateExamRegistrationPaid = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/examregistration/paid",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let account = response.data;
  if (typeof account !== "object") {
    account = null;
  }
  return account;
};

const updateExamRegistration = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/examregistration",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let account = response.data;
  if (typeof account !== "object") {
    account = null;
  }
  return account;
};

const updateExamRegistrationMarks = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/examregistrationmarks",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let exam = response.data;
  if (typeof exam !== "object") {
    exam = null;
  }
  return exam;
};

const getSubjects = async function() {
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + "/subjects"
  );

  let subjects = parseList(response);
  return subjects;
};

const getTeachers = async function() {
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + "/teachers"
  );
  let teachers = parseList(response);
  return teachers;
};

const getPendingAccounts = async function() {
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + "/pendingaccounts"
  );
  let pendingAccounts = parseList(response);
  return pendingAccounts;
};

const getParents = async function(token, page, itemsPerPage, sortBy, search) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL +
      "/parents?page=" +
      page +
      "&pageSize=" +
      itemsPerPage +
      "&sortExpression=" +
      sortBy +
      "&search=" +
      search
  );
  let parents = parseList(response);
  return parents;
};

const getExamFees = async function() {
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + "/examfees"
  );
  let examFees = parseList(response);
  return examFees;
};

const getLocations = async function() {
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + "/locations"
  );

  let locations = parseList(response);
  return locations;
};

const getExams = async function(
  id,
  isHideFinalized,
  subjectId,
  gradeLevel,
  token,
  page,
  itemsPerPage,
  sortBy,
  search
) {
  axios.defaults.headers.common["Authorization"] = token;
  console.log(
    "calling",
    process.env.VUE_APP_SERVICE_URL +
      "/schoolyear/" +
      id +
      "/exams?page=" +
      page +
      "&pageSize=" +
      itemsPerPage +
      "&sortExpression=" +
      sortBy +
      "&isHideFinalized=" +
      isHideFinalized +
      "&subjectId=" +
      subjectId +
      "&gradeLevel=" +
      gradeLevel +
      "&search=" +
      search
  );
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL +
      "/schoolyear/" +
      id +
      "/exams?page=" +
      page +
      "&pageSize=" +
      itemsPerPage +
      "&sortExpression=" +
      sortBy +
      "&isHideFinalized=" +
      isHideFinalized +
      "&subjectId=" +
      subjectId +
      "&gradeLevel=" +
      gradeLevel +
      "&search=" +
      search
  );
  let exams = parseList(response);
  console.log("exams result", exams);
  return exams;
};

const parseList = (response) => {
  if (response.status !== 200) throw Error(response.message);
  if (!response.data) return [];
  let list = response.data;
  if (typeof list !== "object") {
    list = [];
  }
  return list;
};

const getTeacher = async function(id, token) {
  try {
    axios.defaults.headers.common["Authorization"] = token;
    const response = await axios.get(
      process.env.VUE_APP_SERVICE_URL + "/teacher/" + id
    );

    if (response.status !== 200) throw Error(response.message);
    if (!response.data) {
      return null;
    }
    console.log("response.data", response.data);
    let teacher = response.data;
    if (typeof teacher !== "object") {
      teacher = null;
    }
    return teacher;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getTransactions = async function(id, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + "/account/" + id + "/transactions"
  );
  let transactions = parseList(response);
  return transactions;
};

const getCreditRecords = async function(id, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + "/account/" + id + "/creditrecords"
  );
  let creditRecords = parseList(response);
  return creditRecords;
};

const getSchoolYearCurrent = async function() {
  try {
    console.log("in getSchoolYearCurrent");
    const response = await axios.get(
      process.env.VUE_APP_SERVICE_URL + "/schoolyear/current"
    );
    console.log("response", response);

    if (response.status !== 200) throw Error(response.message);
    if (!response.data) {
      return null;
    }
    console.log("response.data", response.data);
    let schoolYear = response.data;
    if (typeof schoolYear !== "object") {
      schoolYear = null;
    }
    return schoolYear;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getSchoolYears = async function() {
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + "/schoolyears"
  );
  let schoolYears = parseList(response);
  return schoolYears;
};

const updateSchoolYear = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/schoolyear",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let schoolYear = response.data;
  if (typeof schoolYear !== "object") {
    schoolYear = null;
  }
  return schoolYear;
};

const updateLocation = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/location",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let location = response.data;
  if (typeof location !== "object") {
    location = null;
  }
  return location;
};

const updateExamFee = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/examfee",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let examFee = response.data;
  if (typeof examFee !== "object") {
    examFee = null;
  }
  return examFee;
};

const updateTeacherIsActive = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + "/teacher",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let teacher = response.data;
  if (typeof teacher !== "object") {
    teacher = null;
  }
  return teacher;
};

const payCart = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.post(
    process.env.VUE_APP_SERVICE_URL + "/cart/pay",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let data = response.data;
  if (typeof data !== "object") {
    data = null;
  }
  return data;
};

const linkStudent = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.post(
    process.env.VUE_APP_SERVICE_URL + "/account/linkname",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let data = response.data;
  if (typeof data !== "object") {
    data = null;
  }
  return data;
};

const moveChildren = async function(model, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.post(
    process.env.VUE_APP_SERVICE_URL + "/account/move",
    model
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let data = response.data;
  if (typeof data !== "object") {
    data = null;
  }
  return data;
};

const getExamRegistrationSummary = async function(schoolYearId, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + "/examregistrations/summary/" + schoolYearId
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let data = response.data;
  if (typeof data !== "object") {
    data = null;
  }
  return data;
};

const getExamRegistrationDetail = async function(schoolYearId, subjectId, gradeLevel, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + "/examregistrations/detail/" + schoolYearId + "/" + subjectId + "/" + gradeLevel
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let data = response.data;
  if (typeof data !== "object") {
    data = null;
  }
  return data;
};

const getMarksDetail = async function(schoolYearId, subjectId, gradeLevel, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + "/marks/detail/" + schoolYearId + "/" + subjectId + "/" + gradeLevel
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let data = response.data;
  if (typeof data !== "object") {
    data = null;
  }
  return data;
};

const getFeesDetail = async function(schoolYearId, isPaid, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + "/fees/detail/" + schoolYearId + "/" + (isPaid ? "true" : "false")
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let data = response.data;
  if (typeof data !== "object") {
    data = null;
  }
  return data;
};

const getAdminTransactionsDetail = async function(startDate, endDate, token) {
  axios.defaults.headers.common["Authorization"] = token;
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + "/admintransactions?startdate=" + startDate + "&enddate=" + endDate
  );

  console.log("response.status", response.status);

  if (response.status !== 200) throw Error(response.message);
  if (!response.data) {
    return null;
  }
  console.log("response.data", response.data);
  let data = response.data;
  if (typeof data !== "object") {
    data = null;
  }
  return data;
};

export const dataService = {
  forgotPassword,
  getAccount,
  updateAccount,
  updatePassword,
  addChild,
  updateChild,
  getSubjects,
  getTeachers,
  getExamFees,
  addExamRegistration,
  deleteExamRegistration,
  getTeacher,
  getParents,
  updateExamRegistrationPaid,
  updateExamRegistration,
  getExams,
  updateExamRegistrationMarks,
  getSchoolYearCurrent,
  getSchoolYears,
  updateSchoolYear,
  payCart,
  updateTeacherIsActive,
  getTransactions,
  deleteChild,
  refundExamRegistration,
  getAccountCredit,
  updateExamRegistrationCredit,
  getCreditRecords,
  addCreditRecord,
  checkEmail,
  updateAccountEmail,
  linkStudent,
  deleteSchoolYear,
  addSchoolYear,
  deleteParent,
  updateExamFee,
  moveChildren,
  getLocations,
  updateLocation,
  addLocation,
  deleteLocation,
  getExamRegistrationSummary,
  getExamRegistrationDetail,
  getMarksDetail,
  getFeesDetail,
  getAdminTransactionsDetail,
  getPendingAccounts,
  deletePendingAccount,
  confirmPendingAccount
};
